import script from "./DistributionMap.vue?vue&type=script&lang=ts&setup=true&name=ShopEdit"
export * from "./DistributionMap.vue?vue&type=script&lang=ts&setup=true&name=ShopEdit"

import "./DistributionMap.vue?vue&type=style&index=0&id=0cdc6a5e&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cdc6a5e"]])

export default __exports__